// extracted by mini-css-extract-plugin
export default {"numberContainer":"DraggableActionItem_numberContainer__wk6ur","draggableBullet":"DraggableActionItem_draggableBullet__CQEPG"};